import { truncateText } from './truncate-text';

const DEFAULT_MAX_LEGEND_LABEL_WIDTH = 90;

const truncateLegendLabel = (
  label: string,
  maxWidth: number = DEFAULT_MAX_LEGEND_LABEL_WIDTH
): string => {
  if (!label || typeof label !== 'string') {
    return String(label ?? '');
  }

  // fontFamily intentionally omitted: truncateText defaults to the family the
  // active appearance actually renders (TWK Lausanne Pan themed / Source Sans
  // legacy), so the width budget tracks the real glyphs.
  return truncateText({
    text: label,
    maxWidth,
    fontSize: 11,
  });
};

export const createLegendLabelFormatter = (
  maxWidth: number = DEFAULT_MAX_LEGEND_LABEL_WIDTH
) => {
  return (label: string) => truncateLegendLabel(label, maxWidth);
};
